export const BASE_URL = 'https://api.dev.tiqs.in/onboarding';
export const ENV = 'development';

type Step = {
  name: string;
  step: number;
};

export const steps: Step[] = [
  { name: 'mobile_verification', step: 0 },
  { name: 'pan_verification', step: 1 },
  { name: 'email_verification', step: 2 },
  { name: 'personal_details', step: 3 },
  { name: 'bank_details', step: 4 },
  { name: 'liveliness_detection', step: 5 },
  { name: 'declaration', step: 6 },
  { name: 'signature', step: 7 },
  { name: 'aadhaar_e_sign_documents', step: 8 },
];

export const popularBanksList = [
  {
    code: 'SBIN',
    name: 'State Bank of India',
  },
  {
    code: 'HDFC',
    name: 'HDFC Bank',
  },
  {
    code: 'ICIC',
    name: 'ICICI Bank',
  },
  {
    code: 'UTIB',
    name: 'Axis Bank',
  },
  {
    code: 'INDB',
    name: 'Indusind Bank',
  },
  {
    code: 'BKID',
    name: 'Bank of India',
  },
  {
    code: 'CBIN',
    name: 'Central Bank of India',
  },
  {
    code: 'KKBK',
    name: 'Kotak Mahindra Bank',
  },
];

export const STEP_PROGRESS_MOVEMENT = 8.25;
export const allStepsArray = [
  'email_verification',
  'pan_verification',
  'aadhaar_verification',
  'personal_details',

  'bank_details',
  'liveliness_detection',
  'declaration',
  'signature',

  'nominee',
  'income_proof',
  'aadhaar_e_sign_documents',
  'e_sign_completed',
];

export const RESEND_OTP_TIMER = 30;

export const ErrorFallback = 'Something went wrong'
